import React from 'react';

const Header = () => {
    return (
        <div className="text-start bg-info text-light">
            <div className="container py-3">
                <h2>Online PC Builder</h2>
                <p className="py-3">Hey There, This is our <span className="fw-bold">Online PC Builder!</span> <br />
                Website here you can select product's and you can see how much it will be cost !</p>
            </div>
        </div>
    );
};

export default Header;